import { LocalTime } from '@js-joda/core'

interface MinutesAndSeconds {
  minutes: number
  seconds: number
}
/**
 * Converts miliseconds to an object containing Minutes and seconds, Eg. 55,000 to:
 * "{
 *    minutes: 9,
 *    seconds: 10"
 *  }
 */
export function msToMinutesAndSeconds(ms: number): MinutesAndSeconds {
  const MILLISECONDS_IN_SECONDS = 1000

  const seconds = ms / MILLISECONDS_IN_SECONDS
  const minutes = seconds >= LocalTime.SECONDS_PER_MINUTE && seconds / LocalTime.SECONDS_PER_MINUTE

  if (minutes) {
    const remainingSeconds = seconds % LocalTime.SECONDS_PER_MINUTE
    return {
      seconds: Math.round(remainingSeconds),
      minutes: Math.round(minutes),
    }
  }

  return {
    seconds: Math.round(seconds),
    minutes: 0,
  }
}
